import Image from '../../../components/Image'
import {
  Medal,
} from './styles'
import medalOneImage from '../../../assets/medals/medal_1.png';
import medalTwoImage from '../../../assets/medals/medal_2.png';
import medalThreeImage from '../../../assets/medals/medal_3.png';
import medalFourImage from '../../../assets/medals/medal_4.png';
import medalFiveImage from '../../../assets/medals/medal_5.png';
import medalSixImage from '../../../assets/medals/medal_6.png';
import medalSevenImage from '../../../assets/medals/medal_7.png';
import medalHeightImage from '../../../assets/medals/medal_8.png';
import medalNineImage from '../../../assets/medals/medal_9.png';
import medalTenImage from '../../../assets/medals/medal_10.png';
import medalExtraImage from '../../../assets/medals/medal_11.png';
import { CategoryDto } from '../../../types/category';

const medals = [
  medalOneImage,
  medalTwoImage,
  medalThreeImage,
  medalFourImage,
  medalFiveImage,
  medalSixImage,
  medalSevenImage,
  medalHeightImage,
  medalNineImage,
  medalTenImage,
]

interface ComponentProps {
  category: CategoryDto
  width: string,
  height: string
}

const UnlockedCategoryMedal = ({ category, width = "32px", height = "45px" }: ComponentProps) => {
  if (!category?.locked_ordinal) {
    return <></>
  }
  return (
    <Medal>
      <Image src={medals[category?.locked_ordinal - 1] || medalExtraImage} width={width} height={height} />
    </Medal>
  )
}

export default UnlockedCategoryMedal